import { createTheme } from "@mui/material";
import { themeColors } from "utils/themeColors";

// Set CSS custom properties for dynamic theming
const setThemeVariables = () => {
  const root = document.documentElement;
  root.style.setProperty('--primary-color', themeColors.primaryColor);
  root.style.setProperty('--secondary-color', themeColors.secondaryColor);
  root.style.setProperty('--black-color', themeColors.blackColor);
  root.style.setProperty('--grey-color', themeColors.greyColor);
  root.style.setProperty('--medium-grey-color', themeColors.mediumGreyColor);
  root.style.setProperty('--light-grey-color', themeColors.lightGreyColor);
  root.style.setProperty('--red-color', themeColors.redColor);
  root.style.setProperty('--green-color', themeColors.greenColor);
  root.style.setProperty('--blue-color', themeColors.blueColor);
  root.style.setProperty('--yellow-color', themeColors.yellowColor);
  root.style.setProperty('--violet-color', themeColors.violetColor);
  root.style.setProperty('--white-color', themeColors.whiteColor);
  root.style.setProperty('--light-blue-color', themeColors.lightBlueColor);
  root.style.setProperty('--sky-blue-color', themeColors.skyBlueColor);
  root.style.setProperty('--light-pink-color', themeColors.lightPinkColor);
  root.style.setProperty('--light-orange-color', themeColors.lightOrangeColor);
  root.style.setProperty('--dark-red-color', themeColors.darkRedColor);
  root.style.setProperty('--light-green-color', themeColors.lightGreenColor);
  root.style.setProperty('--light-black-color', themeColors.lightBlackColor);
};

// Initialize theme variables when module loads
setThemeVariables();

export const theme = createTheme({
  root: {
    margin: "inherit"
  },
  components: {
    // Name of the component
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: "0px"
        }
      }
    }
  },
  typography: {
    margin: 0,
    head: {
      fontSize: "100px",
    },
    head1: {
      fontSize: "64px",
    },
    head2: {
      fontSize: "36px",
    },
    head3: {
      fontSize: "28px",
    },
    head4: {
      fontSize: "24px",
    },
    head5: {
      fontSize: "20px",
    },
    body1: {
      fontSize: "18px",
    },
    body2: {
      fontSize: "16px",
    },
    body3: {
      fontSize: "14px",
    },
    body4: {
      fontSize: "12px",
    },
    body5: {
      fontSize: "11px",
    },
    body6: {
      fontSize: "10px",
    },
    body7: {
      fontSize: "9px",
    },
    textLarge: {
      fontSize: "48px",
    }
  },
});

export { setThemeVariables };

// $fontHead: 100px;
// $fontHead1: 64px;
// $fontHead2: 36px;
// $fontHead3: 28px;
// $fontHead4: 24px;
// $fontHead5: 20px;

// $fontBody1: 18px;
// $fontBody2: 16px;
// $fontBody3: 14px;
// $fontBody4: 12px;
// $fontBody5: 11px;
// $fontBody6: 10px;
// $fontBody7: 7px;
